import axiosInstance from '../helpers/axiosInstance';

export const getGroupApi = async (pageNo, searchKey, sort = {}) => {
    let url;
    if (Object.keys(sort).length === 2) {
        url = `public/quotationMaterialGroup?sortField=${sort.sortField}&sortMethod=${sort.sortType}&page=${pageNo}&searchKey=${searchKey}`;
    } else {
        url = searchKey !== undefined
            ? `public/quotationMaterialGroup?searchKey=${searchKey}&page=${pageNo}`
            : `public/quotationMaterialGroup?page=${pageNo}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createGroupApi = async (request) => {
    const response = await axiosInstance.post('admin/quotationMaterialGroup', request.formData);
    return response.data;
};

export const getOneGroupApi = async (quotationMaterialGroupId) => {
    const response = await axiosInstance.get(`admin/quotationMaterialGroup/${quotationMaterialGroupId}`);
    return response.data;
};

export const updateGroupApi = async (request) => {
    const response = await axiosInstance.put('admin/quotationMaterialGroup', request.formData);
    return response.data;
};
